import React, { useState } from 'react'; // ✅ useState 추가
import { useNavigate } from 'react-router-dom';
// ✅ src 폴더 바로 아래에 있는 로고 이미지 참조
import campusLogo from '../campus-life.png';

function Header() {
    const navigate = useNavigate();
    const [showLogoutModal, setShowLogoutModal] = useState(false); // ✅ 모달 상태 관리

    // 로컬스토리지에서 로그인된 사용자 정보 가져오기
    const user = JSON.parse(localStorage.getItem('currentUser'));
    const userName = user ? user.name : '사용자';

    // ✅ 로그아웃 실행 함수
    const confirmLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
        setShowLogoutModal(false);
        navigate('/');
    };

    return (
        <header style={headerStyle}>
            {/* 왼쪽: 로고 + 서비스명 */}
            <div style={leftContainer} onClick={() => navigate('/main')}>
                <img src={campusLogo} alt="Logo" style={logoStyle} />
                <span style={titleStyle}>Campus Life Assistant</span>
            </div>

            {/* 로그아웃은 메인 대시보드 헤더에서 처리 */}
        </header>
    );
}

// --- 기존 스타일 설정 ---
const headerStyle = {
    height: '60px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 40px',
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1000,
    boxSizing: 'border-box'
};

const leftContainer = {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '12px'
};

const logoStyle = {
    height: '35px',
    width: 'auto'
};

const titleStyle = {
    fontSize: '20px',
    fontWeight: '700',
    color: '#4A90E2',
    letterSpacing: '-0.5px'
};

const rightContainer = {
    display: 'flex',
    alignItems: 'center',
    gap: '20px'
};

const userNameStyle = {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333'
};

const logoutButtonStyle = {
    padding: '8px 16px',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    color: '#666',
    transition: 'all 0.2s'
};

// ✅ 모달 전용 스타일 추가
const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
};

const modalContentStyle = {
    backgroundColor: '#fff',
    padding: '30px 40px',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    textAlign: 'center',
    minWidth: '300px'
};

const modalTitleStyle = {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    margin: '0 0 25px 0'
};

const modalButtonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: '12px'
};

const confirmButtonStyle = {
    padding: '10px 25px',
    backgroundColor: '#4A90E2',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600'
};

const cancelButtonStyle = {
    padding: '10px 25px',
    backgroundColor: '#eee',
    color: '#333',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600'
};

export default Header;
